// model/index.ts
export * from "prosemirror-model";